import { BusinessLine } from '@cemex-core/cmx-api/models/business-lines/business-line';
import { Order } from '@cemex-core/cmx-api/models/order-management/order';
import { OrderBuilderActions, RESET_BUILDER } from '../../order-builder/actions/order-builder.actions';
import { OneClickOrdersActions, OneClickOrdersActionTypes } from '../actions/one-click-orders.actions';
import { OrderStrategyResponse } from '../../order-builder/models/order-strategy-response';

export interface OneClickOrdersState {
  loading: boolean;
  placing: boolean;
  ordersAvailable: Order[];
  selected: Order;
  selectedFromTable: boolean;
  canUseBusinessline: BusinessLine | boolean;
  result: OrderStrategyResponse;
  addingReceivingPerson: boolean;
  valid: boolean;
}

export const initialState: OneClickOrdersState = {
  loading: false,
  placing: false,
  ordersAvailable: null,
  selected: null,
  selectedFromTable: false,
  canUseBusinessline: false,
  result: null,
  addingReceivingPerson: false,
  valid: null,
};

export function reducer(
  state = initialState,
  action: OneClickOrdersActions | OrderBuilderActions,
): OneClickOrdersState {
  switch (action.type) {
    case OneClickOrdersActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      } as OneClickOrdersState;
    }
    case OneClickOrdersActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        ordersAvailable: action.payload,
      } as OneClickOrdersState;
    }
    case OneClickOrdersActionTypes.PLACE_ORDER: {
      return {
        ...state,
        placing: true,
      } as OneClickOrdersState;
    }
    case OneClickOrdersActionTypes.PLACE_ORDER_COMPLETED: {
      return {
        ...state,
        placing: false,
        result: action.payload,
      } as OneClickOrdersState;
    }
    case OneClickOrdersActionTypes.UPDATE_ORDER:
    case OneClickOrdersActionTypes.SELECT_ORDER: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickOrdersState;
    }
    case OneClickOrdersActionTypes.SELECTED_ORDER_FROM_TABLE: {
      return {
        ...state,
        selectedFromTable: action.payload,
      } as OneClickOrdersState;
    }
    case OneClickOrdersActionTypes.SET_RECEIVING_PERSON_NAME: {
      return {
        ...state,
        selected: {
          ...state.selected,
          contact: {
            ...state.selected.contact,
            contactName: action.payload,
          },
        },
      } as OneClickOrdersState;
    }
    case OneClickOrdersActionTypes.SET_RECEIVING_PERSON_PHONE: {
      return {
        ...state,
        selected: {
          ...state.selected,
          contact: {
            ...state.selected.contact,
            contactPhone: action.payload,
          },
        },
      } as OneClickOrdersState;
    }
    case OneClickOrdersActionTypes.TOGGLE_ADDING_RECEIVING_PERSON: {
      return {
        ...state,
        addingReceivingPerson: !state.addingReceivingPerson,
      } as OneClickOrdersState;
    }
    case OneClickOrdersActionTypes.SET_VALID_ORDER: {
      return {
        ...state,
        valid: action.payload,
      } as OneClickOrdersState;
    }
    case OneClickOrdersActionTypes.SELECT_ORDER_DETAIL_ERROR:
    case RESET_BUILDER:
    case OneClickOrdersActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    case OneClickOrdersActionTypes.TOGGLE_ADDING_RECEIVING_PERSON: {
      return {
        ...state,
        addingReceivingPerson: !state.addingReceivingPerson,
      } as OneClickOrdersState;
    }

    case OneClickOrdersActionTypes.HAS_BUSINESSLINE_RIGHT: {
      return {
        ...state,
        canUseBusinessline: action.payload,
      } as OneClickOrdersState;
    }
    default: {
      return state;
    }
  }
}
